var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 57,
    viewBox: "0 0 49 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.875 55.625H32.125V53.75H34.875V55.625ZM37.75 55.625H38.6298C40.6982 55.625 42.375 53.9408 42.375 51.8923V50H40.5V51.8874C40.5 52.9157 39.6606 53.75 38.6251 53.75H37.75V55.625ZM29.25 55.625H26.5V53.75H29.25V55.625ZM23.625 55.625H20.875V53.75H23.625V55.625ZM18 55.625H15.25V53.75H18V55.625ZM11.375 55.625H10.4952C8.42049 55.625 6.75 53.9399 6.75 51.8613V50H8.625V51.8835C8.625 52.9143 9.47758 53.75 10.4999 53.75H11.375V55.625ZM42.375 47.125V43.375H40.5V47.125H42.375ZM6.75 47.125V43.375H8.625V47.125H6.75ZM42.375 40.5V36.75H40.5V40.5H42.375ZM6.75 40.5V36.75H8.625V40.5H6.75ZM46.25 32V28.25H48.125V37.625H46.25V33.875H2.875V37.625H1V28.25H2.875V32H46.25ZM42.375 29.125V14.125L31.125 1H10.5052C8.43125 1 6.75 2.68438 6.75 4.76374V29.125H8.625V4.74148C8.625 3.72862 9.46075 2.875 10.4917 2.875H29.25V12.2389C29.25 14.3377 30.9272 16 32.9961 16H40.5V29.125H42.375ZM31.125 3.8125V12.2335C31.125 13.2782 31.97 14.125 32.9939 14.125H39.9374L31.125 3.8125Z",
    fill: "",
    stroke: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanfile);
export default __webpack_public_path__ + "static/media/scanfile.b70966eddfd9ae0834348438e275dc36.svg";
export { ForwardRef as ReactComponent };